import { assert, isDefined } from '@sama/js-core';
import { DoubleSide, Mesh, PlaneGeometry } from 'three';
import { Point3D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { H3BasicMaterial } from '../../../materials/basic/h3-basic-material';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';
import { RendererLayer, setRendererLayers } from '../../render-utils';
import {
  AbstractMeshHelper,
  ConfigureMeshesConfiguration,
} from '../abstract-mesh-helper';
import { MeasurementColors } from '../color-utils';
import { subpointRadius } from '../poly-shape/abstract-polyshape-helper';

export const planeSize = subpointRadius * 10;

export class MeasurementPlaneHelper extends AbstractMeshHelper {
  private plane = new Mesh<PlaneGeometry, H3BasicMaterial>(
    new PlaneGeometry(planeSize, planeSize),
  );

  constructor() {
    super();
    this.plane.userData = { meshType: 'MeasurementPlane' };
  }

  setPosition(position: Point3D) {
    this.plane.position.fromArray(position);
  }

  override updateRendererLayers(_state: PointCloudContentState) {
    setRendererLayers([RendererLayer.Main], this.plane);
  }

  override getMeshes() {
    return [this.plane];
  }

  override dispose() {
    this.plane.geometry.dispose();
  }

  protected override configureMeshes({
    state,
    materialService,
  }: ConfigureMeshesConfiguration) {
    const { subpointHeightMeasurement } = state.render;
    assert(
      isDefined(subpointHeightMeasurement),
      'SubpointHeightMeasurement should be defined when measuring sub point height',
    );
    const { active } = subpointHeightMeasurement;
    this.plane.material = materialService.get(H3BasicMaterial, {
      color: active ? MeasurementColors.HighLight : MeasurementColors.Standard,
      side: DoubleSide,
      transparent: true,
      opacity: 0.3,
    });
  }
}
